import React from 'react';
import { useTimerContext } from 'context/hooks/useTimerContext';

const Timer: React.FC = () => {
  const { minutes, seconds } = useTimerContext();

  return (
    <div>
      <p className="text-center text-[10px] font-normal text-[#9E9E9E]">
        Expires in{' '}
        <span className="text-[#0284F8]">
          {minutes}:{seconds}
        </span>
      </p>
    </div>
  );
};

export default Timer;
